












































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Budget from '~/models/budget';
import moment from 'moment';
import FormatHelper from '~/helpers/format-helper';
import transport from '~/models/transport';
import Info from '~/components/icons/Info.vue';

@Component({
	components: { Info },
})
export default class Sidebar extends Vue {
	@Prop({ default: new Budget(), required: true }) private model;
	@Prop({ required: false, default: 1 }) private step; // 2: Alojamiento, 3: Transporte, 4: Extras, 5: Actividades

	@Watch('model')
	model_change(value: any) {
		this.budget = value;
		if (this.budget.activity) {
			this.budget.activity = this.budget.activity.sort((a, b) => {
				return a.day - b.day;
			});
		}
		this.extra_service_price();
		// this.total = this.budget.total_amount;
	}

	private budget: Budget;
	private total: any = 0;
	private teacher_price: any = 0;
	private totalStudent: any = 0;

	constructor() {
		super();
		this.budget = new Budget();
	}

	created() {
		this.budget = new Budget();
		if (this.model) {
			this.budget = this.model;
			if (this.budget.activity) {
				this.budget.activity = this.budget.activity.sort((a, b) => {
					return a.day - b.day;
				});
			}
			this.extra_service_price();
			// this.total = this.model.total_amount;
		}
	}

	formatDate(date, format) {
		if (date) {
			return moment(String(date)).format(format);
		}
	}

	get transportName() {
		return this.budget.transport['transport_prices'][0].name;
	}

	get accommodationRequiredTotal() {
		let total = 0;
		if (this.budget.accommodation_price) {
			total += this.budget.accommodation_price;
		}
		const people = this.budget.teachers + this.budget.students;
		if (this.budget.accommodation.prices) {
			for (let price of this.budget.accommodation.prices) {
				if (price.group == 1) {
					total += price.price / people;
				} else {
					total += price.price;
				}
			}
		}
		total = total * this.nights;
		return total;
	}

	get transportRequiredTotal() {
		let total = 0;
		for (let price of this.budget.transport['transport_prices']) {
			total += price.price;
		}
		return total;
	}

	activityRequiredTotal(activity) {
		let total = 0;
		for (let price of activity['prices_sidebar']) {
			total += parseFloat(price.price);
		}
		return total;
	}

	calulateDays() {
		if (this.budget.start_date && this.budget.end_date) {
			const start = moment(this.budget.end_date).diff(moment(this.budget.start_date), 'days') + 1;
			const end = moment(this.budget.end_date).diff(moment(this.budget.start_date), 'days');
			const res = '(' + start + ' días y ' + end + ' noches)';
			return res;
		} else {
			return '';
		}
	}


	extra_service_price(student = 0) {
		console.log('test movil inicio', this.budget);
		if (this.budget.accommodation_price) {
			const people = this.budget.teachers + this.budget.students;
			this.totalStudent = this.budget.accommodation_price;
			if (this.budget.accommodation.prices) {
				for (let price of this.budget.accommodation.prices) {
					if (price.group == 1) {
						this.totalStudent += price.price / people;
					} else {
						this.totalStudent += price.price;
					}
				}
			}
			if (this.budget.accommodation.extras) {
				for (const accommodationExtra of this.budget.accommodation.extras) {
					this.totalStudent += accommodationExtra.price;
				}
			}
			this.totalStudent = this.totalStudent * this.nights;
		}
		if (this.budget.transport && this.budget.transport['transport_prices']) {
			for (const transportPrice of this.budget.transport['transport_prices']) {
				this.totalStudent += transportPrice.price;
			}
			for (const transportExtra of this.budget.transport['extras']) {
				this.totalStudent += transportExtra.price;
			}
		}
		let discount = 0;
		if (this.budget.extra_service && this.budget.extra_service.length != 0) {
			this.budget.extra_service.forEach(a => {
				this.totalStudent += a.extras.value;
				if (a.extras.discount) {
					discount += a.extras.discount;
				}
			});
		}
		if (this.budget.activity) {
			this.budget.activity = this.budget.activity.sort((a, b) => {
				return a.day - b.day;
			});
			this.budget.activity.forEach(a => {
				this.totalStudent += parseFloat(a.total);
				if (a.extras) {
					a.extras.forEach(b => {
						this.totalStudent += parseFloat(b.price);
					});
				}
				// this.totalStudent += a.totalStudent.reduce((b, c) => {return b + c});
			});
		}
		this.total = this.totalStudent;
		this.teacher_price = this.totalStudent;
		this.total -= discount;
		if (this.formatPrice(this.budget.teachers - this.budget.students / this.budget.free_teacher_by_students) != 0) {
			let supplement = this.getSupplement();
			this.totalStudent += supplement;
			this.total += supplement;
		}
		this.total = parseFloat(String(Math.round(this.total * 100) / 100)).toFixed(2);
		this.totalStudent = parseFloat(String(Math.round(this.totalStudent * 100) / 100)).toFixed(2);
		console.log('total', this.total);
		this.$emit('updateTotal', this.total);
	}

	get nights() {
		return Math.abs(moment(this.budget.start_date).diff(moment(this.budget.end_date), 'days'));
	}

	formatPrice(value) {
		return FormatHelper.formatPrice(value);
	}

	deleteAccommodationExtra(accommodationExtraIndex, extraId) {
		this.budget.accommodation.extras.splice(accommodationExtraIndex, 1);
		for (const extraIndex in this.budget.accommodation_extras) {
			if (this.budget.accommodation_extras[extraIndex].id == extraId) {
				this.budget.accommodation_extras.splice(extraIndex, 1);
				break;
			}
		}
		this.extra_service_price();
	}

	deleteExtraService(extraServiceIndex) {
		this.budget.extra_service.splice(extraServiceIndex, 1);
		this.extra_service_price();
	}

	deleteRequiredTransport() {
		const aux_state_id = this.budget.transport.state_id;
		this.budget.transport = new transport();
		this.budget.transport.state_id = aux_state_id;
		this.extra_service_price();
		this.$emit('updateTransport', this.budget.transport);
	}

	deleteRequiredAccomodation() {
		//this.budget.accommodation = null;
		//this.extra_service_price();
		this.$emit('update', 2);
	}

	deleteTransportExtra(transportIndex, priceId) {
		this.budget.transport.extras.splice(transportIndex, 1);
		for (const extraIndex in this.budget.transport_extras) {
			if (this.budget.transport_extras[extraIndex].id == priceId) {
				this.budget.transport_extras.splice(extraIndex, 1);
				break;
			}
		}
		if (this.budget.transport.transport_price_ids) {
			// Esto es por si se quita algún precio desde el sidebar en otro paso que no sea transporte
			const idsIndex = this.budget.transport.transport_price_ids.indexOf(priceId);
			if (idsIndex > -1) {
				this.budget.transport.transport_price_ids.splice(idsIndex, 1);
			}
		}
		this.extra_service_price();
		this.$emit('updateTransport', this.budget.transport);
	}

	deleteActivity(activityIndex, extraIndex = null) {
		if (extraIndex == null) {
			this.budget.activity.splice(activityIndex, 1);
		} else {
			this.budget.activity[activityIndex].extras.splice(extraIndex, 1);
			this.budget.activity[activityIndex].extras_sidebar.splice(extraIndex, 1);
		}
	}

	getSupplement() {
		let teacher_amount = 0;
		if (this.budget.teachers > (this.budget.students / this.budget.free_teacher_by_students)) {
			let amount_with_supplement = ((this.budget.supplement * this.teacher_price) / 100) + this.teacher_price;
			teacher_amount = (amount_with_supplement / this.budget.students) *
				(this.budget.teachers - ~~(this.budget.students / this.budget.free_teacher_by_students));
		}
		return teacher_amount;
	}


	getPaidTeachers() {
		let paid_teachers = 0;
		if (this.budget.teachers > (this.budget.students / this.budget.free_teacher_by_students)) {
			paid_teachers = this.budget.teachers - ~~(this.budget.students / this.budget.free_teacher_by_students);
		}
		return paid_teachers;
	}
}
